import { Flex } from 'antd';
import styled from 'styled-components';

export const StageContainer = styled(Flex)<{ $colorBgBase: string }>`
  background-color: ${({ $colorBgBase }) => $colorBgBase};
  padding: 12px;
  width: 100%;
  margin-bottom: 12px;
  border-radius: 12px 12px 0 0;
  white-space: nowrap;
`;
